'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _themeManager = require('../../../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

var _breakpoints = require('../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _Carousel = require('../../carousel/main/jsx/Carousel');

var _Carousel2 = _interopRequireDefault(_Carousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var ORGANISM_NAME = 'step-flow';
var AUTOPLAY_TIMER = 6000;

var StepsFlow = function (_Component) {
  _inherits(StepsFlow, _Component);

  function StepsFlow() {
    _classCallCheck(this, StepsFlow);

    var _this = _possibleConstructorReturn(this, (StepsFlow.__proto__ || Object.getPrototypeOf(StepsFlow)).call(this));

    _this.renderHeadline = function (headline) {
      if (headline) {
        return _react2.default.createElement(
          _heading2.default,
          { className: ORGANISM_NAME + '__headline', level: '2' },
          htmlToReactParser.parse(headline.text)
        );
      }
      return null;
    };

    _this.renderCTA = function (cta) {
      if (cta) {
        return _react2.default.createElement(
          _button2.default,
          {
            id: cta.id,
            href: cta.href,
            color: cta.color || null,
            className: ORGANISM_NAME + '__cta',
            fpti: 'Stepsflow-cta-' + (cta.fpti || cta.text),
            target: cta.target || '_self'
          },
          cta.text
        );
      }
      return null;
    };

    _this.renderParagraph = function (paragraph) {
      if (paragraph) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__paragraph pp-sans-big-light' },
          htmlToReactParser.parse(paragraph.text)
        );
      }
      return null;
    };

    _this.renderHatchContent = function (hatchText) {
      if (hatchText) {
        return _react2.default.createElement(
          'p',
          { className: ORGANISM_NAME + '__hatch-text legal-notes' },
          htmlToReactParser.parse(hatchText.text)
        );
      }
      return null;
    };

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleAutoPlay = _this.handleAutoPlay.bind(_this);
    _this.state = {
      selectedStep: 0,
      hoverStep: undefined,
      isMobile: false,
      autoPlay: true
    };
    return _this;
  }

  _createClass(StepsFlow, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      this.handleAutoPlay();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'getCircleClass',
    value: function getCircleClass(idx) {
      var _cx;

      return (0, _classnames2.default)(ORGANISM_NAME + '__circle-col__wrapper__button__circle', (_cx = {}, _defineProperty(_cx, ORGANISM_NAME + '__circle-col__wrapper__button__circle--hover', parseInt(this.state.hoverStep, 10) === idx), _defineProperty(_cx, ORGANISM_NAME + '__circle-col__wrapper__button__circle--active', parseInt(this.state.selectedStep, 10) === idx), _cx));
    }
  }, {
    key: 'getParagraphClass',
    value: function getParagraphClass(idx) {
      return (0, _classnames2.default)(ORGANISM_NAME + '__circle-col__wrapper__button__content pp-sans-big-light', _defineProperty({}, ORGANISM_NAME + '__circle-col__wrapper__button__content--active pp-sans-small-medium', !this.state.isMobile && parseInt(this.state.selectedStep, 10) === idx));
    }
  }, {
    key: 'getImageClass',
    value: function getImageClass(idx) {
      return (0, _classnames2.default)(ORGANISM_NAME + '__image-container__image', _defineProperty({}, ORGANISM_NAME + '__image-container__image--invisible', !(parseInt(this.state.selectedStep, 10) === idx)));
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      this.setState({
        selectedStep: parseInt(event.currentTarget.getAttribute('data-key'), 10)
      });
    }
  }, {
    key: 'handleMouseEnter',
    value: function handleMouseEnter(event) {
      this.setState({
        hoverStep: parseInt(event.currentTarget.getAttribute('data-key'), 10)
      });
    }
  }, {
    key: 'handleMouseLeave',
    value: function handleMouseLeave() {
      this.setState({
        hoverStep: undefined
      });
    }
  }, {
    key: 'handleAutoPlay',
    value: function handleAutoPlay() {
      var _this2 = this;

      window.setInterval(function () {
        if (!_this2.state.isMobile && _this2.state.autoPlay) {
          _this2.setState({
            selectedStep: _this2.state.selectedStep + 1 >= _this2.props.content.steps.length ? 0 : _this2.state.selectedStep + 1
          });
        }
      }, AUTOPLAY_TIMER);
    }
  }, {
    key: 'handleResize',
    value: function handleResize() {
      var newWindowWidth = Math.min(this.organismRef.ownerDocument.defaultView.innerWidth, this.organismRef.ownerDocument.documentElement.clientWidth, this.organismRef.ownerDocument.body.clientWidth);

      if (newWindowWidth >= _breakpoints2.default.large) {
        if (this.state.isMobile) {
          this.setState({
            isMobile: false
          });
        }
      } else if (!this.state.isMobile) {
        this.setState({
          isMobile: true
        });
      }
    }
  }, {
    key: 'renderByViewPort',
    value: function renderByViewPort(steps, primaryCta, hatchText) {
      if (this.state.isMobile) {
        return this.renderCarousel(steps, primaryCta, hatchText);
      }
      return this.renderSteps(steps, primaryCta, hatchText);
    }
  }, {
    key: 'renderContent',
    value: function renderContent(steps) {
      var _this3 = this;

      return steps.map(function (elem, idx) {
        var elemKey = '' + elem.paragraph.text + idx;
        return _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__body', key: elemKey },
          _react2.default.createElement(
            'div',
            {
              className: ORGANISM_NAME + '__circle-col',
              onClick: _this3.handleClick,
              onMouseEnter: _this3.handleMouseEnter,
              onMouseLeave: _this3.handleMouseLeave,
              'data-key': idx,
              tabIndex: '-1',
              role: 'button',
              onKeyUp: function onKeyUp() {}
            },
            _this3.state.isMobile ? _react2.default.createElement(
              'div',
              { className: ORGANISM_NAME + '__circle-col__wrapper' },
              _react2.default.createElement(
                'span',
                { className: _this3.getCircleClass(idx) },
                _react2.default.createElement(
                  'div',
                  { className: ORGANISM_NAME + '__circle-col__wrapper__button__circle__text' },
                  idx + 1
                )
              ),
              _react2.default.createElement(
                'p',
                { className: _this3.getParagraphClass(idx) },
                htmlToReactParser.parse(elem.paragraph.text)
              )
            ) : _react2.default.createElement(
              'button',
              { className: ORGANISM_NAME + '__circle-col__wrapper__button' },
              _react2.default.createElement(
                'span',
                { className: _this3.getCircleClass(idx) },
                _react2.default.createElement(
                  'div',
                  { className: ORGANISM_NAME + '__circle-col__wrapper__button__circle__text' },
                  idx + 1
                )
              ),
              _react2.default.createElement(
                'p',
                { className: _this3.getParagraphClass(idx) },
                htmlToReactParser.parse(elem.paragraph.text)
              )
            ),
            _this3.state.isMobile && _react2.default.createElement('img', {
              src: elem.image.src,
              alt: elem.image.alt,
              className: ORGANISM_NAME + '__carousel__image'
            })
          )
        );
      });
    }
  }, {
    key: 'renderImages',
    value: function renderImages(steps) {
      var _this4 = this;

      return steps.map(function (elem, idx) {
        var elemKey = '' + elem.image.src + idx;
        return _react2.default.createElement(
          'div',
          { className: ORGANISM_NAME + '__image-container', key: elemKey },
          _react2.default.createElement('img', { className: _this4.getImageClass(idx), src: elem.image.src, alt: elem.image.alt })
        );
      });
    }
  }, {
    key: 'renderSteps',
    value: function renderSteps(steps, cta, hatchText) {
      if (steps) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: ORGANISM_NAME + '__flex-wrapper row' },
            _react2.default.createElement(
              'div',
              { className: ORGANISM_NAME + '__steps-container col-lg-6 col-md-12 col-sm-12' },
              this.renderContent(steps),
              _react2.default.createElement(
                'div',
                { className: ORGANISM_NAME + '__cta' },
                this.renderCTA(cta)
              ),
              this.renderHatchContent(hatchText)
            ),
            _react2.default.createElement(
              'div',
              { className: ORGANISM_NAME + '__flex-item col-lg-6 col-md-12 col-sm-12' },
              this.renderImages(steps)
            )
          )
        );
      }
      return null;
    }
  }, {
    key: 'renderCarousel',
    value: function renderCarousel(steps, primaryCta, hatchText, trackId) {
      var _this5 = this;

      var options = {
        startSlide: 0,
        speed: 400,
        className: ORGANISM_NAME,
        continuous: false
      };
      return _react2.default.createElement(
        'div',
        { className: ORGANISM_NAME + '__wrapper' },
        _react2.default.createElement(
          _Carousel2.default,
          {
            ref: function ref(c) {
              _this5.carousel = c;
            },
            className: ORGANISM_NAME + '__carousel',
            trackId: trackId || 'StepFlow-Carousel',
            options: options
          },
          this.renderContent(steps)
        ),
        this.renderCTA(primaryCta),
        this.renderHatchContent(hatchText)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var newProps = (0, _themeManager2.default)(this.props, this.props.config.theme);

      var content = newProps.content,
          config = newProps.config,
          className = newProps.className;
      var headline = content.headline,
          steps = content.steps,
          primaryCta = content.primaryCta,
          paragraph = content.paragraph,
          hatchText = content.hatchText;
      var id = config.id,
          theme = config.theme;


      var stepsClasses = (0, _classnames2.default)('' + ORGANISM_NAME, theme || 'theme-background-color-white', className);

      var headClasses = (0, _classnames2.default)('row ' + ORGANISM_NAME + '__head', _defineProperty({}, ORGANISM_NAME + '__head--extra-padding', !paragraph));

      return _react2.default.createElement(
        'section',
        {
          ref: function ref(c) {
            _this6.organismRef = c;
          },
          className: stepsClasses,
          'data-building-block': 'organism',
          id: id,
          onMouseEnter: function onMouseEnter() {
            return _this6.setState({ autoPlay: false });
          },
          onMouseLeave: function onMouseLeave() {
            return _this6.setState({ autoPlay: true });
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: headClasses },
            this.renderHeadline(headline),
            this.renderParagraph(paragraph)
          ),
          this.renderByViewPort(steps, primaryCta, hatchText)
        )
      );
    }
  }]);

  return StepsFlow;
}(_react.Component);

// ESLint disabled for className because className are used, but
// it is processed before being used and ESLint doesn not detect that.


exports.default = StepsFlow;
StepsFlow.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-blue', 'theme-background-color-light', 'theme-background-color-white']).isRequired
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    cta: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    carousel: _propTypes2.default.shape({
      goToSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToNextSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      goToPreviousSlide: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      })
    }),
    steps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      paragraph: _propTypes2.default.shape({
        text: _propTypes2.default.string.isRequired
      }),
      image: _propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired,
        alt: _propTypes2.default.string
      })
    })).isRequired
  }),
  /* eslint-disable */
  className: _propTypes2.default.string
  /* eslint-enable */
};

StepsFlow.defaultProps = {
  config: {
    theme: 'theme-background-color-white',
    id: ''
  },
  content: {
    headline: {
      text: 'Headline = 34 or fewer characters.'
    },
    paragraph: {
      text: 'Optional body copy will go here and go here. Do not exceed more than 140 characters.'
    },
    primaryCta: {
      id: '',
      href: '#',
      text: '29 characters maximum'
    },
    hatchText: {
      text: 'Any Legal disclaimer will go here. No more than 200 characters per disclosure.'
    },
    carousel: {
      goToSlide: {
        text: 'Go to slide'
      },
      goToNextSlide: {
        text: 'Go to next slide'
      },
      goToPreviousSlide: {
        text: 'Go to previous slide'
      }
    },
    steps: [{
      paragraph: {
        text: 'The 1st step. A minimum of 3 and a maximum of 5 steps. 80 characters' + 'maximum per step.'
      },
      image: {
        src: 'https://www.paypalobjects.com/digitalassets/c/website/guideline/deviceimage-flatbrowser-zshirtco.png',
        alt: ''
      }
    }, {
      paragraph: {
        text: 'Step 2, required. Each step needs a unique image. 80 characters maximum.'
      },
      image: {
        src: 'https://pics.paypal.com/00/s/ZDJjOWMyY2EtNzQ4My00YTFkLThlNDYtN2QzYTM1N2UwMWNh/file.PNG',
        alt: ''
      }
    }, {
      paragraph: {
        text: 'Step 3, required. No links can be used in steps copy. 80 characters maximum.'
      },
      image: {
        src: 'https://www.paypalobjects.com/webstatic/paypalme/images/social/pplogo384.png',
        alt: ''
      }
    }]
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/steps-flow/jsx/StepsFlow.js
// module id = 1149
// module chunks = 4